<template>
  <div class="content">
    <div v-if="loading"></div>
    <div v-else>
      <CCol ref="content" xs="12" lg="12">
        <CCard>
          <CCardHeader
            style=" font-size: 0.875rem; font-weight: 500; letter-spacing: 0.0892857143em; background-color: #428874; color: aliceblue;"
          >
            <md-table style="background-color: #428874; border: none;">
              <md-table-cell
                style="background-color: #428874; color: white; border: none;"
              >
                Nom du secteur: {{ this.fname }}</md-table-cell
              >

              <md-table-cell
                class="-align-right"
                style="background-color: #428874; border: none;"
              >
                <div style="color: aliceblue;width: 100%;">
                  <img
                    :src="vanne"
                    alt
                    width="30"
                    height="10"
                    style=" justify-content: center; margin-bottom:10px; color: white;"
                  />
                  Vanne automatique

                  <span v-if="!isConnected">
                    <i
                      class="fas fa-exclamation-circle"
                      style="color: red;"
                    ></i>
                  </span>

                  <toggle-button
                    :disabled="!isConnected"
                    :value="On_Off == 30 ? false : true"
                    color="#4287f5"
                    :labels="true"
                    @change="isConnected ? edit_on_off(On_Off, nodeId) : null"
                  />
                </div>
              </md-table-cell>
            </md-table>
          </CCardHeader>
          <CCardBody>
            <v-tabs grow color="basil" v-model="activeTab">
              <v-tab
                @click="
                  openLoading();
                  activeTab = 0;
                "
                >Données du capteur</v-tab
              >
              <v-tab
                @click="
                  openLoading();
                  activeTab = 1;
                "
                >Données météo</v-tab
              >
              <v-tab
                @click="
                  openLoading();
                  activeTab = 2;
                "
                >Informations de la parcelle</v-tab
              >

              <v-tab-item>
                <div style="margin-top: 50px;">
                  <div
                    style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="4" sm="4">
                        <template>
                          <v-bottom-navigation v-model="value">
                            <v-btn value="month" @click="load_data('month')">
                              <span> dernier mois</span>
                              <v-icon color="#b9a26c">
                                mdi-calendar-month
                              </v-icon>
                            </v-btn>
                            <v-btn value="week" @click="load_data('week')">
                              <span> semaine dernière </span>

                              <v-icon color="#b9a26c"
                                >mdi-calendar-range
                              </v-icon>
                            </v-btn>
                            <v-btn value="day" @click="load_data('day')">
                              <span> 2 derniers jours </span>
                              <v-icon color="#b9a26c"> mdi-history </v-icon>
                            </v-btn>
                          </v-bottom-navigation>
                        </template>
                      </v-col>

                      <v-col cols="8" sm="4">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="date"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="date"
                              label="Date range:"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>

                   

                          <v-date-picker
                          v-model="dates"
                          class="mt-4"
                          :max="nowDate"
                          range
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="load_data(dates), $refs.dialog.save(dates)"
                          >
                            D'accord
                          </v-btn>
                        </v-date-picker>

                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-card style="padding-top: 20px;  " shaped elevation="4">
                      <v-tabs grow color="basil">
                        <v-tab @click="openLoading">
                          <v-icon color="#b9a26c">mdi-water-percent</v-icon>
                          Données du sol
                        </v-tab>

                        <v-tab
                          v-if="this.nodeId[0] == 'z'"
                          @click="openLoading"
                        >
                          <v-icon color="#b9a26c"
                            >mdi-lightning-bolt-outline</v-icon
                          >
                          EC (mS/cm)
                        </v-tab>

                           <v-tab @click="openLoading">
                          <v-icon color="#b9a26c">mdi-thermometer-lines</v-icon>
                          Température du sol (°C)
                        </v-tab> 

                        <v-tab
                          @click="openLoading"
                          v-if="
                            this.nodeId != 'z6-19027' &&
                              this.nodeId != 'z6-19028' &&
                              this.nodeId != 'z6-19029' &&
                              this.nodeId != 'z6-19030'
                          "
                        >
                          <v-icon color="#b9a26c"
                            >mdi-collapse-all-outline</v-icon
                          >
                          Données atmosphériques
                        </v-tab>

                        <v-tab
                          @click="openLoading"
                          v-if="
                            this.nodeId != 'z6-19027' &&
                              this.nodeId != 'z6-19028' &&
                              this.nodeId != 'z6-19029' &&
                              this.nodeId != 'z6-19030'
                          "
                        >
                          <v-icon color="#b9a26c">mdi-water-outline</v-icon>
                          Compteur d'eau
                        </v-tab>

                        <!--             :options="watermark_1.options" -->
                        <v-tab-item>
                          <v-row style="margin-top: 40px;">
                            <div class="md-layout-item">
                              <v-card>
                                <!--      <template v-if="show === false">
                                  <CChartLine
                                    :datasets="defaultDatasets"
                                    :labels="watermark_1.data.labels"
                                    :options="watermark_1.options"
                                  >
                                  </CChartLine>
                                </template> -->

                                <template>
                                  <div>
                                    <v-btn
                                      dark
                                      @click="last_value('water')"
                                      :color="last_water ? '#818a87' : '#428874'"
                                      style="margin: 14px;"
                                    >
                                    mode détails
                                    </v-btn>
                                  </div>
                                  <div v-if="this.last_water" class="chart-container">
                                    <vue-echarts
                                      class="echart-container"
                                      autoresize
                                      :option="gaugeOptionWatermark1"
                                    />
                                    <vue-echarts
                                      class="echart-container"
                                      autoresize
                                      :option="gaugeOptionWatermark2"
                                    />
                                    <vue-echarts
                                      class="echart-container"
                                      autoresize
                                      :option="gaugeOptionWatermark3"
                                    />
                                    <vue-echarts
                                      class="echart-container"
                                      autoresize
                                      :option="gaugeOptionWatermark4"
                                    />
                                    <!-- <BarChart></BarChart> -->
                                    <!-- <v-chart :options="chartOptions" style="height: 400px; width: 100%;"></v-chart> -->
                                  </div>
                                  <div v-if="!this.last_water" >
                                    <v-row style="margin-top: 40px;">
                                      <div class="md-layout-item">
                                        <v-card>
                                          <v-row>
                                            <v-col cols="8">
                                              <!--    <v-card-title>
                                                Soil moisture (%)</v-card-title
                                              > -->
                                            </v-col>

                                            <v-col cols="4">
                                        <!--   <v-btn
                                                v-if="type_cmpt != 'Z'"
                                                color="#4CAF50"
                                                elevation="4"
                                                @click="edit_min_max()"
                                                
                                                outlined
                                                small
                                              >
                                                {{ value_scal }}
                                              </v-btn>   -->

                                              <v-btn
                                                @click="show_DS = !show_DS"
                                                color="#4CAF50"
                                                elevation="4"
                                                outlined
                                                small
                                              >
                                                Details
                                                <i
                                                  color="#4CAF50"
                                                  class="fas fa-chevron-down"
                                                  v-if="show_DS === false"
                                                ></i>

                                                <i
                                                  color="#4CAF50"
                                                  class="fas fa-chevron-up"
                                                  v-if="show_DS === true"
                                                ></i>
                                              </v-btn>
                                            </v-col>
                                          </v-row>

                                          <template v-if="show_DS === false">
                                            <CChartLine
                                              :datasets="defaultDatasets"
                                              :labels="watermark_1.data.labels"
                                              :options="watermark_1.options"
                                            >
                                            </CChartLine>
                                          </template>
                                          <v-divider
                                            v-if="show_DS === false"
                                            inset
                                          ></v-divider>
                                          <label class="labels_chart" v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z')">{{ this.get.p1 }}</label>
                                          
                                          <template v-if="show_DS === true">
                                            <CChartLine
                                              :datasets="data_water1"
                                              :labels="watermark_1.data.labels"
                                              :options="watermark_1.options"
                                            >
                                            </CChartLine>
                                            
                                          </template>
                                          <v-divider
                                            v-if="show_DS === true"
                                            inset
                                          ></v-divider>
                                          <br/>
                                          <label class="labels_chart" v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z')">{{ this.get.p2 }}</label>
                                          <template v-if="show_DS === true ">
                                            <CChartLine
                                              :datasets="data_water2"
                                              :labels="watermark_2.data.labels"
                                              :options="watermark_2.options"
                                            >
                                            </CChartLine>
                                          </template>

                                          <v-divider
                                            v-if="show_DS === true"
                                            inset
                                          ></v-divider>
                                          <br/>
                                          <label class="labels_chart" v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') && this.get.nbr >= 3">{{ this.get.p3 }}</label>
                                          <template v-if="show_DS === true  ">
                                            <CChartLine
                                              :datasets="data_water3"
                                              :labels="watermark_3.data.labels"
                                              :options="watermark_3.options"
                                            >
                                            </CChartLine>
                                          </template>
                                          <v-divider
                                            v-if="show_DS === true && this.nbr >= 3"
                                            inset
                                          ></v-divider>
                                          <br/>
                                          <label class="labels_chart" v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') && this.get.nbr >= 4">{{ this.get.p4 }}</label>
                                          <template v-if="show_DS === true ">
                                            <CChartLine
                                              :datasets="data_water4"
                                              :labels="watermark_4.data.labels"
                                              :options="watermark_4.options"
                                            >
                                            </CChartLine>
                                          </template>
                                          <v-divider
                                            v-if="show_DS === true "
                                            inset
                                          ></v-divider>
                                          <label class="labels_chart" v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') && this.get.nbr >= 5">{{ this.get.p5 }}</label>
                                          <template v-if="show_DS === true  && (nodeId[0] == 'z'  || nodeId[0] == 'Z')">
                                            <CChartLine
                                              :datasets="data_water5"
                                              :labels="watermark_5.data.labels"
                                              :options="watermark_5.options"
                                            >
                                            </CChartLine>
                                          </template>
                                          <v-divider
                                            v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z')"
                                            inset
                                          ></v-divider>
                                          <template v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') ">
                                            <CChartLine
                                              :datasets="data_water5"
                                              :labels="watermark_5.data.labels"
                                              :options="watermark_5.options"
                                            >
                                            </CChartLine>
                                          </template>
                                       <!--    <v-divider
                                            v-if="show_DS === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') "
                                            inset
                                          ></v-divider>
                                          <template
                                            v-if="
                                              show_DS === true &&
                                                this.nodeId != 'z6-05840-2' &&
                                                this.prof_pycno == '4'
                                            "
                                          >
                                            <CChartLine
                                              :datasets="data_water3"
                                              :labels="watermark_3.data.labels"
                                              :options="watermark_2.options"
                                            >
                                            </CChartLine>
                                          </template> -->

                                     <!--      <v-divider
                                            v-if="
                                              show_DS === true && this.nodeId != 'z6-05840-2' && (nodeId[0] == 'z'  || nodeId[0] == 'Z')
                                            "
                                            inset
                                          ></v-divider>
 -->
                                       <!--    <template
                                            v-if="
                                              show_DS === true &&
                                            (nodeId[0] != 'z'  && nodeId[0] != 'Z') &&
                                                this.prof_pycno == '4'
                                            "
                                          >
                                            <CChartLine
                                              :datasets="data_water4"
                                              :labels="watermark_4.data.labels"
                                              :options="watermark_1.options"
                                            >
                                            </CChartLine>
                                          </template> -->
 
                                        </v-card>
                                      </div>
                                    </v-row>
                                  </div>
                                </template>

                                <v-divider inset></v-divider>
                              </v-card>
                            </div>
                          </v-row>
                        </v-tab-item>
                       
                        <v-tab-item>
                          <v-divider
                            inset
                            v-if="(nodeId[0] != 'z'  && nodeId[0] != 'Z')"
                          ></v-divider>

                          <v-row
                            style="margin-top: 20px;"
                            v-if="(nodeId[0] != 'z'  && nodeId[0] != 'Z')"
                          >
                            <div class="md-layout-item">
                              <v-card elevation="4" outlined>
                                <v-row>
                                  <v-col cols="8">
                                    <!--   <v-card-title>
                                      Soil Temperature (°C)
                                    </v-card-title> -->
                                  </v-col>

                                  <v-col
                                    cols="4"
                                    v-if="this.nodeId != 'z6-05840-2'"
                                  >
                                    <v-btn
                                      @click="show_SL = !show_SL"
                                      color="#4CAF50"
                                      elevation="4"
                                      outlined
                                      small
                                    >
                                      Details
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-down"
                                        v-if="show_SL === false"
                                      ></i>
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-up"
                                        v-if="show_SL === true"
                                      ></i>
                                    </v-btn>
                                  </v-col>
                                </v-row>

                                <template v-if="show_SL === false">
                                  <CChartLine
                                    :datasets="soil_T_all"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="show_SL === false"
                                  inset
                                ></v-divider>

                                <template
                                  v-if="
                                    show_SL === true && soil_T_1[0].data.length > 0
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_1"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="
                                    show_SL === true 
                                  "
                                  inset
                                ></v-divider>

                                <template
                                  v-if="
                                    show_SL === true && soil_T_2[0].data.length > 0
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_2"
                                    :labels="soil_temperature2.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_SL === true  && soil_T_2[0].data.length > 0
                                  "
                                  inset
                                ></v-divider>
                                <template
                                  v-if="
                                    show_SL === true && soil_T_3[0].data.length > 0
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_3"
                                    :labels="soil_temperature3.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_SL === true  && soil_T_3[0].data.length > 0
                                  "
                                  inset
                                ></v-divider>
                                <template
                                  v-if="
                                    show_SL === true && soil_T_4[0].data.length > 0
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_4"
                                    :labels="soil_temperature4.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_SL === true  && soil_T_4[0].data.length > 0
                                  "
                                  inset
                                ></v-divider>
                                
                              </v-card>
                            </div>
                          </v-row>

                          <v-row
                            style="margin-top: 40px;"
                            v-if = "(nodeId[0] == 'z'  || nodeId[0] == 'Z')"
                          >
                            <div class="md-layout-item">
                              <v-card elevation="4" outlined>
                                <v-row>
                                  <v-col cols="8">
                                  </v-col>

                                  <v-col
                                    cols="4"
                                    v-if="this.nodeId != 'z6-05840-2'"
                                  >
                                    <v-btn
                                      @click="show_SL = !show_SL"
                                      color="#4CAF50"
                                      elevation="4"
                                      outlined
                                      small
                                    >
                                      Details
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-down"
                                        v-if="show_SL === false"
                                      ></i>
                                      <i
                                        color="#4CAF50"
                                        class="fas fa-chevron-up"
                                        v-if="show_SL === true"
                                      ></i>
                                    </v-btn>
                                  </v-col>
                                </v-row>

                                <template v-if="show_SL === false">
                                  <CChartLine
                                    :datasets="soil_T_all"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>

                                <v-divider
                                  v-if="show_SL === false"
                                  inset
                                ></v-divider>
                                <label class="labels_chart" v-if="show_SL === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z')">{{ this.get.p1 }}</label>
                                <template
                                  v-if="
                                    show_SL === true &&
                                      this.nodeId != 'z6-05840-2'
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_1"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider
                                  v-if="
                                    show_SL === true
                                  "
                                  inset
                                ></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') ">{{ this.get.p2 }}</label>
                                <template
                                  v-if="
                                    show_SL === true"
                                >
                                  <CChartLine
                                    :datasets="soil_T_2"
                                    :labels="soil_temperature1.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider  v-if="
                                    show_SL === true 
                                  " inset></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') ">{{ this.get.p3 }}</label>
                                <template
                                  v-if="
                                    show_SL === true &&   this.nodeId != 'z6-05840' 
                                  "
                                >
                                  <CChartLine
                                    :datasets="soil_T_3"
                                    :labels="soil_temperature2.data.labels"
                                    :options="watermark_3.options"
                                  >
                                  </CChartLine>
                                </template> 
                                <v-divider v-if="
                                    show_SL === true 
                                  " inset></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true && (nodeId[0] == 'z'  || nodeId[0] == 'Z') ">{{ this.get.p4 }}</label>
                                <template
                                  v-if="
                                    show_SL === true &&   this.nodeId != 'z6-05840' 
                                  "
                                >
                                  <CChartLine 
                                    :datasets="soil_T_4"
                                    :labels="soil_temperature3.data.labels"
                                    :options="watermark_4.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider v-if="
                                    show_SL === true 
                                  " inset></v-divider>
                                <br/>
                                <label class="labels_chart" v-if="show_SL === true  && (nodeId[0] == 'z'  || nodeId[0] == 'Z')">Port 5</label>
                                <template
                                  v-if="
                                    show_SL === true &&   this.get.nbr >= 5
                                  "
                                >
                                  <CChartLine 
                                    :datasets="soil_T_5"
                                    :labels="soil_temperature4.data.labels"
                                    :options="watermark_4.options"
                                  >
                                  </CChartLine>
                                </template>
                                <v-divider inset></v-divider>
                              </v-card>
                            </div>
                          </v-row>
                        </v-tab-item>

                        <v-tab-item
                          v-if="
                            this.nodeId != 'z6-19027' &&
                              this.nodeId != 'z6-19028' &&
                              this.nodeId != 'z6-19029' &&
                              this.nodeId != 'z6-19030'
                          "
                        >
                          <v-card
                            elevation="4"
                            outlined
                            style="margin-top: 40px;"
                          >
                            <v-divider inset></v-divider>

                            <v-row>
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_Temp_air"
                                    :labels="Temp_air.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider
                              v-if="this.nodeId[0] != 'z'"
                              inset
                            ></v-divider>
                            <v-row v-if="this.nodeId[0] != 'z'">
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_Sunlight"
                                    :labels="Sunlight.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider inset></v-divider>
                            <v-row>
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_air_humidity"
                                    :labels="air_humidity.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider inset></v-divider>
                            <v-row v-if="this.nodeId[0] == 'z'">
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_rssi"
                                    :labels="rssi.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider inset></v-divider>
                            <v-row v-if="this.nodeId[0] != 'z'">
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_lqi"
                                    :labels="lqi.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider inset></v-divider>
                          </v-card>
                        </v-tab-item>

                        <!-- Counter Water  -->
                        <v-tab-item
                          v-if="
                            this.nodeId != 'z6-19027' &&
                              this.nodeId != 'z6-19028' &&
                              this.nodeId != 'z6-19029' &&
                              this.nodeId != 'z6-19030'
                          "
                        >
                          <v-card
                            elevation="4"
                            outlined
                            style="margin-top: 40px;"
                          >
                            <v-divider inset></v-divider>

                            <v-row>
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_water_count_flow"
                                    :labels="Water_count_Flow_Meter.data.labels"
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>

                            <v-divider inset></v-divider>

                            <v-row>
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_water_count_meter"
                                    :labels="
                                      Water_count_Water_Meter.data.labels
                                    "
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>

                            <v-divider inset></v-divider>

                            <v-row>
                              <div class="md-layout-item">
                                <template>
                                  <CChartLine
                                    :datasets="data_water_Quantity_meter"
                                    :labels="
                                      Water_count_Quantity_meter.data.labels
                                    "
                                    :options="watermark_2.options"
                                  >
                                  </CChartLine>
                                </template>
                              </div>
                            </v-row>
                            <v-divider inset></v-divider>
                          </v-card>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>

                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
                    >
                      <v-row>
                        <!--    <v-col>
                              <v-btn
                            v-if="show === false"
                            @click="show = !show"
                            color="success"
                          >
                            <i
                              style="color: white"
                              class="fas fa-chevron-down"
                            ></i>
                            Show More Details
                          </v-btn> 

                          <v-btn v-else @click="show = !show" color="success">
                            <i style="color: white" class="fas fa-angle-up"></i>
                            Hide Details
                          </v-btn>
                        </v-col>-->
                        <v-col>
                          <v-btn
                            dark
                            @click="change = true"
                            color="#428874"
                            style="margin: 14px;"
                          >
                            <i style="color: white" class="fas fa-download"></i>
                            exporter
                          </v-btn>


                          <vs-dialog
                            overflow-hidden
                            v-model="change"
                            width="600px"
                          >
                            <div>
                              <div class="modal-header">
                                <v-card-title>Exporter des données</v-card-title>
                                <!-- <h5 class="modal-title">Update profile</h5> -->
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span></span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <v-card-text
                                  >
                                  Pour exporter des données, veuillez choisir une date de début et une date de fin

                                  </v-card-text
                                >
                                <!-- <p>To save changes insert your current password</p> -->
                                <div
                                  class="md-layout-item md-small-size-100 md-size-90"
                                >
                                  <v-row>
                                    <v-col>
                                      Début :
                                      <v-row>
                                        <v-col>
                                          <vs-input
                                            v-model="start"
                                            type="date"
                                          />
                                        </v-col>
                                        <v-col>
                                          <vs-input
                                            type="time"
                                            v-model="starttime"
                                            max="nowDate"
                                          />
                                        </v-col> </v-row
                                      >
                                      Fin :
                                      <v-row>
                                        <v-col>
                                          <vs-input v-model="end" type="date" />
                                        </v-col>
                                        <v-col>
                                          <vs-input
                                            type="time"
                                            v-model="endtime"
                                          />
                                        </v-col>
                                      </v-row>

                                      <v-row>
                                        <!--   <v-col>
                                          <v-checkbox
                                            v-model="checkbox_one_houre"
                                            :label="'Hourly Data'"
                                            @change="change_($event)"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col> -->

                                        <v-col>
                                          <v-checkbox
                                            v-model="checkbox_one_12h"
                                            :label="'Données journalières'"
                                            @change="change_1($event)"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col>

                                        <!--    <v-col
                                          style="height:20px; display: flex; justify-content: flex-end"
                                        >
                                          <v-checkbox
                                            v-model="checkbox_one_day"
                                            @change="change_2($event)"
                                            :label="'Daily Data'"
                                            color="success"
                                          >
                                          </v-checkbox>
                                        </v-col> -->
                                      </v-row>

                                      <!-- <v-text-field v-model="Limit" label="Choose Number of Limit data*" required></v-text-field> -->
                                    </v-col>
                                  </v-row>
                                </div>
                              </div>
                              <div>
                                <v-row
                                  style="justify-content: flex-end; margin-right: 40px;"
                                >
                                  <v-btn
                                    color="blue darken-1"
                                    class="ma-2"
                                    :loading="loading1"
                                    :disabled="loading1"
                                    text
                                    @click="ft_export"
                                  >
                                  exporter
                                    <template v-slot:loader>
                                      <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                      </span>
                                    </template>
                                  </v-btn>
                                </v-row>
                                <v-row></v-row>
                              </div>
                            </div>
                          </vs-dialog>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </v-tab-item>

              <v-tab-item>
                <div style="margin-top: 40px;">
                  <v-card
                    style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
                    shaped
                  >
                    <!--    <v-card-title
                      style="justify-content: center; font-size: 45px;"
                      >Weather Data Information</v-card-title
                    > -->
                    <v-row style="margin-top: 50px;">
                      <div class="container col-md-4 col-xl-5">
                        <NewWeather
                          style="border-radius: 25% 10%;"
                          :weath="weath"
                          :time="time"
                          :place="place"
                        />
                      </div>

                      <v-tabs
                        vertical
                        grow
                        color="basil"
                        class="col-md-7 col-xl-7"
                      >
                        <v-tab>Température</v-tab>
                        <v-tab>Humidité</v-tab>
                        <v-tab>Couverture nuageuse</v-tab>
                        <v-tab>Pression</v-tab>
                        <v-tab>Précipitations</v-tab>
                        <v-tab>Vitesse du vent</v-tab>
                        <v-tab-item>
                          <TemperatureChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <TestChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <CloudChart :lab="this.weath" />
                        </v-tab-item>
                        <v-tab-item>
                          <PressureChart :lab="this.weath" />
                        </v-tab-item>

                        <v-tab-item>
                          <PrecipitationChart :lab="this.weath" />
                        </v-tab-item>

                        <v-tab-item>
                          <WindSpeedChart :lab="this.weath" />
                        </v-tab-item>
                      </v-tabs>
                    </v-row>
                  </v-card>
                </div>
              </v-tab-item>

              <v-tab-item>
                <div
                  style="margin-top: 50px; margin-left: 20px; margin-right: 20px; border-color: black;"
                >
                  <v-card
                    style="padding-top: 20px; padding-left: 20px; padding-right: 20px;"
                    shaped
                  >
                    <form>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="fname"
                            label="Nom de l'agriculteur"
                            required
                            @input="$v.fname.$touch()"
                            @blur="$v.fname.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="nodeId"
                            label="Capteur ID"
                            required
                            @input="$v.nodeId.$touch()"
                            @blur="$v.nodeId.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="lat"
                            label="latitude"
                            required
                            @input="$v.lat.$touch()"
                            @blur="$v.lat.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="long"
                            label="longitude"
                            required
                            @input="$v.long.$touch()"
                            @blur="$v.long.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="st"
                            label="Superficie totale"
                            required
                            @input="$v.st.$touch()"
                            @blur="$v.st.$touch()"
                            suffix="ha"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-select
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="items[is]"
                            :items="items"
                            @change="changeRoute_irrig"
                            label=" Système d'irrigation"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="prof_pycno"
                            label="Profondeur du capteur"
                            required
                            @input="$v.prof_pycno.$touch()"
                            @blur="$v.prof_pycno.$touch()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-select
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="items_culture[cult]"
                            :items="items_culture"
                            @change="changeRoute_culture"
                            label="Culture"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col> Densité de la culture :</v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cd1"
                            required
                            @input="$v.cd1.$touch()"
                            @blur="$v.cd1.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>X</v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cd2"
                            required
                            @input="$v.cd2.$touch()"
                            @blur="$v.cd2.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-menu
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="validated ? '' : disabled"
                                id="nour"
                                v-model="date1"
                                label="Date de plantation"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date1"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :disabled="validated ? '' : disabled"
                                id="nour"
                                v-model="dateD"
                                label="Date de début du cycle"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateD"
                              @input="menu3 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="frod"
                            label="Débit des goutteurs"
                            required
                            @input="$v.frod.$touch()"
                            @blur="$v.frod.$touch()"
                            suffix="l/h"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="sod"
                            label="Espacement des goutteurs"
                            required
                            @input="$v.sod.$touch()"
                            @blur="$v.sod.$touch()"
                            suffix="m"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="nor"
                            label="Nombre de rampes/ligne"
                            required
                            @input="$v.nor.$touch()"
                            @blur="$v.nor.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Soil"
                            label="Densité apparente (g/cm3)"
                            required
                            @input="$v.Soil.$touch()"
                            @blur="$v.Soil.$touch()"
                          ></v-text-field>
                          <!--            <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="cou"
                            :error-messages="couErrors"
                            label="Coefficient of uniformity"
                            required
                            @input="$v.cou.$touch()"
                            @blur="$v.cou.$touch()"
                            suffix="%"
                          ></v-text-field> -->
                        </v-col>
                      </v-row>
                      <!--  <v-row>
                        <v-col>
                         <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="ire"
                            :error-messages="ireErrors"
                            label="Irrigation efficiency"
                            required
                            @input="$v.ire.$touch()"
                            @blur="$v.ire.$touch()"
                            suffix="%"
                          ></v-text-field> 
                          
                        </v-col>
                      </v-row>-->
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="oms"
                            label="Matière organique"
                            required
                            @input="$v.oms.$touch()"
                            @blur="$v.oms.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="clay"
                            label="Teneur en argile"
                            required
                            @input="$v.clay.$touch()"
                            @blur="$v.clay.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!--   <v-row>
                        <v-col>
                <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Ss"
                            :error-messages="ssErrors"
                            label="  Soil salinity"
                            required
                            @input="$v.Ss.$touch()"
                            @blur="$v.Ss.$touch()"
                          ></v-text-field>  
                        </v-col>
                        <v-col>
                      
                        </v-col>
                      </v-row> -->
                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="Limon"
                            label="Teneur en limon"
                            required
                            @input="$v.Limon.$touch()"
                            @blur="$v.Limon.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="sand"
                            label="Teneur en sable"
                            required
                            @input="$v.sand.$touch()"
                            @blur="$v.sand.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="min"
                            label="Humidité du sol minimale"
                            required
                            @input="$v.Limon.$touch()"
                            @blur="$v.Limon.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="max"
                            label="Humidité du sol maximale"
                            required
                            @input="$v.sand.$touch()"
                            @blur="$v.sand.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="RFUMIN"
                            label="RFU MIN"
                            required
                            @input="$v.sand.$touch()"
                            @blur="$v.sand.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            :disabled="validated ? '' : disabled"
                            id="nour"
                            v-model="RFUMAX"
                            label="RFU MAX"
                            required
                            @input="$v.Limon.$touch()"
                            @blur="$v.Limon.$touch()"
                            suffix="%"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-btn color="#428874" @click="Myfunction"
                            >Modifier</v-btn
                          >
                        </v-col>
                        <v-col>
                          <span v-if="errdata" style="color: #428874;">{{
                            errdata
                          }}</span>
                          <span v-if="err" style="color: red;">{{ err }}</span>
                        </v-col>
                        <v-col>
                          <v-btn color="#428874" @click="editnode"
                            >Enregistrer</v-btn
                          >
                        </v-col>
                      </v-row>
                    </form>
                  </v-card>
                </div>
              </v-tab-item>
            </v-tabs>
          </CCardBody>
        </CCard>
      </CCol>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import ECharts from 'vue-echarts';
import BarChart from './Bchart.vue';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GaugeChart,
    CanvasRenderer
  ]);

Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);



import { CChartLine } from "@coreui/vue-chartjs";
import moment from "moment";
import FileSaver from "file-saver";
import axios from "axios";
/* import Stepper from "../components/Cards/Stepper"; */
import GetNodes from "@/services/NodeData";
import router from "@/routes";
import DateFo from "../services/DateFormat";
import { mdiWaterPercent, mdiEye, mdiWeatherWindy } from "@mdi/js";
/* import Weather from "@/components/Cards/Weather";
import Temperature from "@/components/Cards/Temperature"; */
import isEmpty from "@/outils/isEmpty";
/* import Measurements from "@/components/Cards/Measurements"; */
import WeatherForecast from "../services/WeatherForecast";
/* import WeatherApp from "@/components/Cards/WeatherApp";
import tempchart from "@/components/Cards/TempChart";
import Chart from "@/components/Charts/LineMarker"; */
import NewWeather from "@/components/Cards/NewWeather";

import TestChart from "@/components/Charts/CChartLineExample";

import CloudChart from "@/components/WeatherCharts/Cloud";
import PressureChart from "@/components/WeatherCharts/Pressure";
import PrecipitationChart from "@/components/WeatherCharts/Precipitation";

import WindSpeedChart from "@/components/WeatherCharts/windSpeed";
import TemperatureChart from "@/components/WeatherCharts/Temperature ";
import TopNavbarVue from "./Layout/TopNavbar.vue";


export default {
  props: {
    vanne: {
      type: String,
      default: require("/public/vanne.png"),
    },
  },
  components: {
    CChartLine,
    TestChart,
    CloudChart,
    PrecipitationChart,
    PressureChart,
    WindSpeedChart,
    TemperatureChart,
    NewWeather,
    BarChart,
    'vue-echarts': ECharts
  },
  data() {
    return {
      // gaugeOption: {
      //     tooltip: {
      //       formatter: '{a} <br/>{b} : {c}%'
      //     },
      //     series: [
      //       {
      //         name: 'Pressure',
      //         type: 'gauge',
      //         detail: { formatter: '{value}%' },
      //         data: [{ value: 50, name: 'SCORE' }]
      //       }
      //     ]
      //   },
      get : this.$router.history.current.query,
      last_water:true,
      isConnected: false,
      params: {
        border: false,
      },

      dates: [
        new Date().toISOString().slice(0, 10),
        new Date().toISOString().slice(0, 10),
      ],
      On_Off: 30,
      value_scal: "Min/Max",
      value: "day",
      nowDate: new Date().toISOString().slice(0, 10),
      modalTest: false,
      starttime: null,
      endtime: null,
      checkbox_one_houre: false,
      checkbox_one_12h: true,
      checkbox_one_day: false,
      change: false,
      colorx: "#8B0000",
      tabs: ["Calculator", "Shopping cart", "Charts"],
      activeTab: 0,
      validated: 1,
      err: null,
      errdata: "",
      select: null,
      items_culture: [
        "Oliviers",
        "Palmier Dattier",
        "Carottes",
        "Onionsc (secs)",
        "Onionsc (verts)",
        "Melons",
        "Pasteques",
        "Bettrave",
        "Mais (grains)",
        "Mais",
        "Agrumes",
        "Caroubier",
        "Pêcher",
        "Nectarine",
        "Prunier",
        "Grenadier",
        "Cognassier",
        "Kaki",
        "Vigne",
      ],
      items: [
        "Irrigation  goutte-à-goutte",
        "Irrigation par aspersion",
        "Irrigation de surface",
      ],
      clay: "",
      Limon: "",

      RFUMAX: "",
      RFUMAX: "",
      sand: "",
      min: "",
      max: "",
      fname: "",
      nodeId: "",
      lat: "",
      cult: "",
      prof_pycno: "",
      long: "",
      st: "",
      ws: "",
      is: null,
      // isn: "",
      cd1: "",
      cd2: "",
      rootd: "",
      frod: "",
      sod: "",
      nor: "",
      cou: "",
      ire: "",
      Ss: "",
      oms: "",
      Soil: "",
      Date_toshow: "",
      temp_time: "",
      e1: 1,
      date1: new Date().toISOString().substr(0, 10),
      dateD: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      menu3: false,
      place: "",
      details: [],
      loader: null,
      loading1: false,
      end: null,
      start: null,
      dialog: false,
      date_req: null,
      date: new Date(),
      forecast: new WeatherForecast(),
      show: false,
      show_DS: true,
      show_EC: true,
      show_SL: true,
      loading: true,
      icons: {
        mdiWaterPercent,
        mdiEye,
        mdiWeatherWindy,
      },
      chartBackgroundPlugin: {
        beforeDraw: (chart) => {
          const ctx = chart.canvas.getContext("2d");
          ctx.fillStyle = "lightblue"; // Set your desired background color
          ctx.fillRect(0, 0, chart.width, chart.height);
        },
      },
      weath: [],
      time: "",
      result: [],
      EC1: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC2: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC3: {
        data: {
          labels: [],
          series: [[]],
        },
      },
      EC4: {
        data: {
          labels: [],
          series: [[]],
        },
      }, 
      watermark_1: {
        data: {
          labels: [],
          datasets: [
            {
              data: [],
              borderColor: "#00aaff",
              fill: false,
              tension: 0.1,
            },
          ],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
            color: {
              type: "color",
              properties: ["borderColor", "backgroundColor"],
              duration: 1000,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
            mode: "nearest",
            hoverBackgroundColor: "#ffaa00",
            hoverBorderColor: "#ffaa00",
          },
          plugins: [this.chartBackgroundPlugin],

          legend: {
              display: true,
              position: "right",
          },

          maintainAspectRatio: true,
          responsive: true,
          scales: {
            x: {
              display: true,
              ticks: {
                callback: function(value, index) {
                  return index % 3 === 0 ? value : "";
                },
                align: "center",
              },
            },
            y: {
              display: true,
              grid: {
                display: true,
              },
              ticks: 
              {
                callback: function(value) {
                  return value;
                },
              },
            },
// modif here

       



         
          },
          elements: {
            line: {
              borderColor: "rgb(0, 123, 255)",
              borderWidth: 2,
            },
            point: {
              radius: 3,
              hoverRadius: 5,
              borderColor: "rgba(0, 0, 0, 0.5)",
              borderWidth: 1,
            },
          },
        },
      },
      watermark_2: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_3: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_4: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      watermark_5: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      soil_temperature1: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      soil_temperature2: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      soil_temperature3: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      soil_temperature4: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      soil_temperature: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },

      air_humidity: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },

      Temp_air: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      Water_count_Flow_Meter: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      Water_count_Quantity_meter: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      Water_count_Water_Meter: {
        data: {
          labels: [],
          series: [[]],
        },
      },

      Sunlight: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      
      Sunlight1: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      Sunlight2: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 1000,
          high: 30000,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      rssi: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          animations: {
            tension: {
              duration: 1000,
              easing: "linear",
              from: 1,
              to: 0,
              loop: true,
            },
          },
          interaction: {
            intersect: false,
          },
          legend: {
            display: true,
            position: "right",
          },
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return index % 3 === 0 ? value : "";
                  },
                },
              },
            ],
          },
        },
      },
      lqi: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 0,
          high: 100,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      battery: {
        data: {
          labels: [],
          series: [[]],
        },
        options: {
          low: 0,
          high: 100,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0.2,
          }),

          axisY: {
            // Lets offset the chart a bit from the labels
            offset: 60,
            // The label interpolation function enables us to modify our values
            // used for the labels on each axis.
            labelInterpolationFnc: function(value) {
              return value;
            },
          },
          // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 2,
          },
        },
      },
      wt1: [],
      timing: [],
    };
  },
  computed: {
    new_data() {
      const parsedRFUMIN = parseFloat(this.RFUMIN);
      const parsedRFUMAX = parseFloat(this.RFUMAX);

      const categories = this.watermark_1.data.labels;
      const series = [
        {
          name: "Humidité à 10cm / mm",
          data: this.watermark_1.data.series[0],
        },
        {
          name: "Humidité à 25cm / mm",
          data: this.watermark_2.data.series[0],
        },
        {
          name: "Humidité à 40cm / mm",
          data: this.watermark_3.data.series[0],
        },
        {
          name: "Humidité à 55cm / mm",
          data: this.watermark_4.data.series[0],
        },
        // {
        //   name: "Température à 10cm / (°C)",
        //   data: this.soil_temperature1.data.series[0],
        // },
        // {
        //   name: "Température à 40cm / (°C)",
        //   data: this.soil_temperature3.data.series[0],
        // },
      ];
      const options = {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: categories,
        },
        yaxis: {
          min: 0, // Minimum value for y-axis
          max: 100, // Maximum value for y-axis
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            },
          },
        },
        annotations: {
          yaxis: [
            {
              y: parsedRFUMAX,
              y2: 100,
              borderColor: "#005a80",
              fillColor: "#005a80",
              opacity: 0.2,
              label: {
                borderColor: "#005a80",
                style: {
                  color: "#fff",
                  background: "#005a80",
                },
                position: "left",
                text: "Sur - irrigation",
                offsetX: 40,
                offsetY: 100,
              },
            },
            {
              y: parsedRFUMIN,
              y2: parsedRFUMAX,
              borderColor: "#008000",
              fillColor: "#008000",
              opacity: 0.2,
              label: {
                borderColor: "#008000",
                style: {
                  fontSize: "10px",
                  color: "#fff",
                  background: "#008000",
                },
                position: "left",
                text: "Confort hydrique",

                offsetX: 40,
                offsetY: 10,
              },
            },
            {
              y: 0,
              y2: parsedRFUMIN,
              borderColor: "#FF0000",
              fillColor: "#FF0000",
              opacity: 0.2,
              label: {
                borderColor: "#FF0000",
                style: {
                  color: "#fff",
                  background: "#FF0000",
                },
                position: "left",
                text: "Stress hydrique",
                offsetX: 40,
                offsetY: 60,
              },
            },
          ],
        },
      };
      return { series, options };
    },
    new_data2() {
      const parsedRFUMIN = parseFloat(this.RFUMIN);
      const parsedRFUMAX = parseFloat(this.RFUMAX);

      const categories = this.watermark_1.data.labels;
      const series = [
        {
          name: "Humidité à 10cm / mm",
          data: this.watermark_1.data.series[0],
        },
        {
          name: "Humidité à 25cm / mm",
          data: this.watermark_2.data.series[0],
        },
        {
          name: "Humidité à 40cm / mm",
          data: this.watermark_3.data.series[0],
        },
        {
          name: "Humidité à 55cm / mm",
          data: this.watermark_4.data.series[0],
        },
        // Add other series from watermark_2, watermark_3, etc.
      ];
      const options = {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: categories,
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            },
          },
        },
        annotations: {
          yaxis: [
            {
              y: parsedRFUMAX,
              y2: 100,
              borderColor: "#005a80",
              fillColor: "#005a80",
              opacity: 0.2,
              label: {
                borderColor: "#005a80",
                style: {
                  color: "#fff",
                  background: "#005a80",
                },
                text: "Sur - irrigation",
              },
            },
            {
              y: parsedRFUMIN,
              y2: parsedRFUMAX,
              borderColor: "#008000",
              fillColor: "#008000",
              opacity: 0.2,
              label: {
                borderColor: "#008000",
                style: {
                  fontSize: "10px",
                  color: "#fff",
                  background: "#008000",
                },
                text: "Confort hydrique",
              },
            },
            {
              y: 0,
              y2: parsedRFUMIN,
              borderColor: "#FF0000",
              fillColor: "#FF0000",
              opacity: 0.2,
              label: {
                borderColor: "#FF0000",
                style: {
                  color: "#fff",
                  background: "#FF0000",
                },
                text: "Stress hydrique",
              },
            },
          ],
        },
      };
      return { options };
    },

    gaugeOptionWatermark1() {
      
      const lastValue = this.watermark_1.data.series[0] ? this.watermark_1.data.series[0][this.watermark_1.data.series[0].length - 1] : 0;
      const lastDate = this.watermark_1.data.labels ? this.watermark_1.data.labels[this.watermark_1.data.labels.length - 1] : 0;
      console.log("-------------------");
      console.log(lastDate);
      return this.createGaugeOption(lastValue, 'Humidité à 10cm',lastDate );
    },
    gaugeOptionWatermark2() {
      const lastValue = this.watermark_2.data.series[0] ? this.watermark_2.data.series[0][this.watermark_2.data.series[0].length - 1] : 0;
      const lastDate = this.watermark_2.data.labels ? this.watermark_2.data.labels[this.watermark_2.data.labels.length - 1] : 0;
      return this.createGaugeOption(lastValue, 'Humidité à 25cm',lastDate);
    },
    gaugeOptionWatermark3() {
      const lastValue = this.watermark_3.data.series[0] ? this.watermark_3.data.series[0][this.watermark_3.data.series[0].length - 1] : 0;
      const lastDate = this.watermark_3.data.labels ? this.watermark_3.data.labels[this.watermark_3.data.labels.length - 1] : 0;
      return this.createGaugeOption(lastValue, 'Humidité à 40cm',lastDate);
    },
    gaugeOptionWatermark4() {
      const lastValue = this.watermark_4.data.series[0] ? this.watermark_4.data.series[0][this.watermark_4.data.series[0].length - 1] : 0;
      const lastDate = this.watermark_4.data.labels ? this.watermark_4.data.labels[this.watermark_4.data.labels.length - 1] : 0;
      return this.createGaugeOption(lastValue, 'Humidité à 55cm',lastDate);
    },



    lastHumidityValue() {
      // Assuming 'watermark_1.data.series[0]' holds the relevant series data
      const series = this.watermark_1.data.series[0];
      if (series && series.length > 0) {
        // Return the last value in the series
        return series[series.length - 1];
      }
      return 0; // Default value if series is empty or undefined
    },
    gaugeOption() {
      return {
        series: [{
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
              borderColor: '#464646'
            }
          },
          axisLine: {
            lineStyle: {
              width: 40
            }
          },
          pointer: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            length: 10,
            distance: 0,
          },
          axisLabel: {
            show: false,
            distance: 50
          },
          data: [{
            value: this.lastHumidityValue, // Dynamically use the last humidity value
            name: 'Humidity',
            title: {
              offsetCenter: ['0%', '-30%']
            },
            detail: {
              offsetCenter: ['0%', '30%']
            }
          }],
          detail: {
            formatter: '{value}%',
            color: 'auto',
            borderColor: 'auto',
            borderWidth: 2,
            width: 50,
            height: 14,
            fontSize: 14,
            borderRadius: 20,
            offsetCenter: [0, '40%']
          }
        }]
      };
    },

    EC_all() {
      if (
        this.nodeId == "z6-19028" ||
        this.nodeId == "z6-19029" ||
        this.nodeId == "z6-19030" ||
        this.nodeId == "z6-19027"
      )
        return [
          {
            label:
              this.nodeId === "z6-19027"
                ? "0 WS50%"
                : this.nodeId === "z6-19028"
                ? "P30 WS50%"
                : this.nodeId === "z6-19029"
                ? "0 WS50%"
                : "P30 WS50%",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.EC1.data.series[0],
          },
          {
            label:
              this.nodeId === "z6-19027"
                ? "0 WS25%"
                : this.nodeId === "z6-19028"
                ? "P30 WS25%"
                : this.nodeId === "z6-19029"
                ? "0 WS25%"
                : "P30 WS25%",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
          {
            label:
              this.nodeId === "z6-19027"
                ? "0 FI100%"
                : this.nodeId === "z6-19028"
                ? "F30 FI100%"
                : this.nodeId === "z6-19029"
                ? "0 FI100%"
                : "F30 FI100%",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
          {
            label:
              this.nodeId === "z6-19027"
                ? "F30 WS50%"
                : this.nodeId === "z6-19028"
                ? "P30 FI100%"
                : this.nodeId === "z6-19029"
                ? "F30 WS50%"
                : "P30 FI100%",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.EC4.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-05840")
        return [
          {
            label: "à 30cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC1.data.series[0],
          },
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-19032")
        return [
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC1.data.series[0],
          },
          {
            label: "à 30cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
          {
            label: "à 60cm / (mS/cm)",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
        ];
      // else if(this.nodeId == "z6-19027")
      // return [
      //     {
      //       label: "à 15cm / (mS/cm)",
      //       backgroundColor: "rgba(228, 255, 26,0.6)",
      //       data: this.EC3.data.series[0],
      //     },
      //     {
      //       label: "à 15cm / (mS/cm)",
      //       backgroundColor: "rgb(14, 173, 83)",
      //       data: this.EC4.data.series[0],
      //     },
      //   ];
      else return null;
    },
    EC1_data() {
      if (this.nodeId === "z6-05840")
        return [
          {
            label: "à 30cm / (mS/cm)",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.EC1.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.EC1.data.series[0],
          },
        ];
    },
    EC2_data() {
      if (this.nodeId === "z6-19032")
        return [
          {
            label: "à 30cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.EC2.data.series[0],
          },
        ];
    },
    EC3_data() {
      if (this.nodeId === "z6-19032")
        return [
          {
            label: "à 60cm / (mS/cm)",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 15cm / (mS/cm)",
            backgroundColor: "rgb(14, 173, 83)",
            data: this.EC3.data.series[0],
          },
        ];
    },
    EC4_data() {
      return [
        {
          label: "à 15cm / (mS/cm)",
          backgroundColor: "rgba(13, 101, 70,0.6)",
          data: this.EC4.data.series[0],
        },
      ];
    },
    soil_T_all() {
      return [
        {
          label: "à 10cm / (°C) ",
          backgroundColor: "rgba(250, 131, 4,0.7)",
          data: this.soil_temperature1.data.series[0],
        },
        {
          label: "à 40cm / (°C)",
          backgroundColor: "rgba(255, 181, 7,0.6)",
          data: this.soil_temperature3.data.series[0],
        },
      ];
    },
    soil_T_1() {
      if (
        this.nodeId === "z6-19027" ||
        this.nodeId === "z6-19028" ||
        this.nodeId === "z6-19029" ||
        this.nodeId === "z6-19030"
      )
        return [
          {
            label: "à 15cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-05840")
        return [
          {
            label: "à 30cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ];
      else if (this.nodeId == "z6-19032")
        return [
          {
            label: "à 15cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 10cm / (°C) ",
            backgroundColor: "rgba(250, 131, 4,0.7)",
            data: this.soil_temperature1.data.series[0],
          },
        ];
    },
    soil_T_2() {
      if (
        this.nodeId === "z6-19027" ||
        this.nodeId === "z6-19028" ||
        this.nodeId === "z6-19029" ||
        this.nodeId === "z6-19030" ||
        this.nodeId === "z6-05840"
      )
        return [
          {
            label: "à 15cm / (°C) ",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
        ];
      else if (this.nodeId === "z6-19032")
        return [
          {
            label: "à 30cm / (°C) ",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 40cm / (°C) ",
            backgroundColor: "rgba(255, 181, 7,0.6)",
            data: this.soil_temperature2.data.series[0],
          },
        ];
    },
    soil_T_3() {
      if (
        this.nodeId === "z6-19027" ||
        this.nodeId === "z6-19028" ||
        this.nodeId === "z6-19029" ||
        this.nodeId === "z6-19030" ||
        this.nodeId === "z6-05840"
      )
        return [
          {
            label: "à 15cm / (°C) ",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ];
      else if (this.nodeId === "z6-19032")
        return [
          {
            label: "à 60cm / (°C) ",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 40cm / (°C) ",
            backgroundColor: "rgba(228, 255, 26,0.6)",
            data: this.soil_temperature3.data.series[0],
          },
        ];
    },
    soil_T_4() {
      if (
        this.nodeId === "z6-19027" ||
        this.nodeId === "z6-19028" ||
        this.nodeId === "z6-19029" ||
        this.nodeId === "z6-19030"
      )
        return [
          {
            label: "à 15cm / (°C) ",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.soil_temperature4.data.series[0],
          },
        ];
      else
        return [
          {
            label: "à 40cm / (°C) ",
            backgroundColor: "rgba(13, 101, 70,0.6)",
            data: this.soil_temperature4.data.series[0],
          },
        ];
    },
    defaultDatasets() {
      return [
        {
          label: "Humidité à 10cm / mm",
          data: this.watermark_1.data.series[0],
          backgroundColor: "rgba(96, 211, 148, 0.6)",
        },
        {
          label: "Humidité à 25cm / mm",
          backgroundColor: "rgba(66, 136, 116, 0.6)",
          data: this.watermark_2.data.series[0],
        },
        {
          label: "Humidité à 40cm / mm",
          backgroundColor: "rgba(82, 165, 243, 0.6)",
          data: this.watermark_3.data.series[0],
        },
        {
          label: "Humidité à 55cm / mm",
          backgroundColor: "rgba(255, 255, 102, 0.6)",
          data: this.watermark_4.data.series[0],
        },
      ];
    },
    data_water1() {
      if (this.value_scal != "Autoscale") {
        if (
          this.nodeId === "z6-19027" ||
          this.nodeId === "z6-19028" ||
          this.nodeId === "z6-19029" ||
          this.nodeId === "z6-19030"
        )
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "#60d394",
              data: this.watermark_1.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-05840")
          return [
            {
              label: "à 30cm / %",
              backgroundColor: "#60d394",
              data: this.watermark_1.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-19032")
          return [
            {
              label: "à 15 cm / %",
              backgroundColor: "#60d394",
              data: this.watermark_1.data.series[0],
            },
          ];
        else
          return [
            {
              label: "à 10cm / mm",
              backgroundColor: "#60d394",
              data: this.watermark_1.data.series[0],
            },
          ];
      } else
        return [
          {
            backgroundColor: "rgb(127, 200, 248,0.8)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Sur - irrigation",
            data: this.watermark_2.data.series[0].map((row) =>
              Number(this.max)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
            fill: "end",
          },
          {
            label: "à 10cm / mm",
            borderColor: "#60d394",
            fill: false,
            data: this.watermark_1.data.series[0],
          },
          {
            backgroundColor: "rgb(220, 47, 2,0.7)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Stress hydrique",
            data: this.watermark_2.data.series[0].map((row) =>
              (
                (Number(this.max) - Number(this.min)) / 3 +
                Number(this.min)
              ).toFixed(0)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
          },
        ];
    },
    data_water2() {
      if (this.value_scal != "Autoscale") {
        if (
          this.nodeId === "z6-19027" ||
          this.nodeId === "z6-19028" ||
          this.nodeId === "z6-19029" ||
          this.nodeId === "z6-19030"
        )
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "rgb(220, 47, 2,0.7)",
              data: this.watermark_2.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-05840")
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "rgb(220, 47, 2,0.7)",
              data: this.watermark_2.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-19032")
          return [
            {
              label: "à 30 cm / %",
              backgroundColor: "rgb(220, 47, 2,0.7)",
              data: this.watermark_2.data.series[0],
            },
          ];
        else
          return [
            {
              label: "à 20cm / mm",
              backgroundColor: "rgb(220, 47, 2,0.7)",
              data: this.watermark_2.data.series[0],
            },
          ];
      } else
        return [
          {
            backgroundColor: "rgb(127, 200, 248,0.8)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Sur - irrigation",
            data: this.watermark_2.data.series[0].map((row) =>
              Number(this.max)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
            fill: "end",
          },
          {
            label: "à 20cm / mm",
            borderColor: "#aaf683",
            data: this.watermark_2.data.series[0],
            fill: false,
          },
          {
            backgroundColor: "rgb(220, 47, 2,0.7)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Stress hydrique",
            data: this.watermark_2.data.series[0].map((row) =>
              (
                (Number(this.max) - Number(this.min)) / 3 +
                Number(this.min)
              ).toFixed(0)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
          },
        ];
    },
    data_water3() {
      if (this.value_scal != "Autoscale") {
        if (
          this.nodeId === "z6-19027" ||
          this.nodeId === "z6-19028" ||
          this.nodeId === "z6-19029" ||
          this.nodeId === "z6-19030"
        )
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "rgb(127, 200, 248,0.8)",
              data: this.watermark_3.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-05840")
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "rgb(127, 200, 248,0.8)",
              data: this.watermark_3.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-19032")
          return [
            {
              label: "à 60 cm / %",
              backgroundColor: "rgb(127, 200, 248,0.8)",
              data: this.watermark_1.data.series[0],
            },
          ];
        else
          return [
            {
              label: "à 40cm / mm",
              backgroundColor: "rgb(127, 200, 248,0.8)",
              data: this.watermark_3.data.series[0],
            },
          ];
      } else {
        return [
          {
            backgroundColor: "rgb(127, 200, 248,0.8)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Sur - irrigation",
            data: this.watermark_2.data.series[0].map((row) =>
              Number(this.max)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
            fill: "end",
          },
          {
            label: "à 40cm / mm",
            borderColor: "#ffd97d",
            data: this.watermark_3.data.series[0],
            fill: false,
          },
          {
            backgroundColor: "rgb(220, 47, 2,0.7)",
            //  hoverBackgroundColor: "#ffb703",
            label: "Stress hydrique",
            data: this.watermark_2.data.series[0].map((row) =>
              (
                (Number(this.max) - Number(this.min)) / 3 +
                Number(this.min)
              ).toFixed(0)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
          },
        ];
      }
    },
    data_water4() {
      if (this.value_scal != "Autoscale") 
      {
        if (
          this.nodeId === "z6-19027" ||
          this.nodeId === "z6-19028" ||
          this.nodeId === "z6-19029" ||
          this.nodeId === "z6-19030"
        )
          return [
            {
              label: "à 15cm / %",
              backgroundColor: "rgba(228, 255, 26,0.6)",
              data: this.watermark_4.data.series[0],
            },
          ];
        else if (this.nodeId === "z6-05840")
          return [
            {
              label: "à 60cm / %",
              backgroundColor: "rgba(228, 255, 26,0.6)",
              data: this.watermark_4.data.series[0],
            },
          ];
        else
          return [
            {
              label: "à 55cm / mm",
              backgroundColor: "rgba(228, 255, 26,0.6)",
              data: this.watermark_4.data.series[0],
            },
          ];
      } else
        return [
          {
            backgroundColor: "rgba(228, 255, 26,0.6)", 
            label: "Sur - irrigation",
            data: this.watermark_2.data.series[0].map((row) =>
             ( Number(this.max ) )
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
            fill: "end",
          },
          {
            backgroundColor: "rgba(228, 255, 26,0.6)", 
            label: "Stress hydrique",
            data: this.watermark_2.data.series[0].map((row) =>
              (
                (Number(this.max) - Number(this.min)) / 3 +
                Number(this.min)
              ).toFixed(0)
            ),
            pointBorderWidth: 0,
            pointHitRadius: 0,
            pointRadius: 0,
            pointStyle: "star",
          },
        ];
    },
    data_water5() {
      return [
        {
          label: "à 30cm / %",
          backgroundColor: "rgb(14, 173, 83)",
          data: this.watermark_5.data.series[0],
        },
      ];
    },
    data_soil_temperature() {
      return [
        {
          label: "Temperature (°C) ",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.soil_temperature.data.series[0],
        },
      ];
    },
    data_air_humidity() {
      return [
        {
          label: "Humidité relative (HR%) ",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.air_humidity.data.series[0],
        },
      ];
    },

    data_Temp_air() {
      return [
        {
          label: "Température de l'air (°C)",
          backgroundColor: "rgba(144, 224, 239,0.8)",
          data: this.Temp_air.data.series[0],
        },
      ];
    },
    data_water_count_flow() {
      return [
        {
          label: "Mesure de débit (L/min)",

          backgroundColor: "rgba(51, 102, 204,0.8)", // This is a shade of blue

          data: this.Water_count_Flow_Meter.data.series[0],
        },
      ];
    },
    data_water_count_meter() {
      return [
        {
          label: "Quantite partielle (L)",
          backgroundColor: "rgba(220, 57, 18, 0.8)", // This is a shade of red
          data: this.Water_count_Water_Meter.data.series[0],
        },
      ];
    },
    data_water_Quantity_meter() {
      return [
        {
          label: "Quantité totale (L)",
          backgroundColor: "rgba(39, 174, 96, 0.8)", // This is a shade of red
          data: this.Water_count_Quantity_meter.data.series[0],
        },
      ];
    },
    data_Sunlight() {
      return [
        {
          label: "Lumière du soleil (Lux)",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.Sunlight.data.series[0],
        },
      ];
    },
    data_rssi() {
      if (this.nodeId[0] == "z")
        return [
          {
            label: "Vapor Pressure Deficit (kPa)",
            backgroundColor: "rgba(226, 175, 255,0.5)",
            data: this.rssi.data.series[0],
          },
        ];
      else
        return [
          {
            label: "Signal strength (dBm) ",
            backgroundColor: "rgba(186, 164, 117,0.5)",
            data: this.rssi.data.series[0],
          },
        ];
    },
    data_lqi() {
      return [
        {
          label: "Radiation solaire (W/m2) ",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.lqi.data.series[0],
        },
      ];
    },
    data_battery() {
      return [
        {
          label: "Battery (V) ",
          backgroundColor: "rgba(186, 164, 117,0.5)",
          data: this.battery.data.series[0],
        },
      ];
    },

    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    year() {
      return this.date.getFullYear();
    },
    period() {
      let hour = this.date.getHours();

      return hour > 5 && hour < 18 ? "app--day" : "app--night";
    },
  },
  methods: {

    last_value(value) { 
      if(value == 'water')
      {
        this.last_water = !this.last_water;
        console.log(value);
        console.log(this.last_water);
      } 
        
      
    },

   
    createGaugeOption(value, name,date) {
      
      
      return {
        series: [{
          type: 'gauge',
          data: [{ value, name }],
          startAngle: 180,
          endAngle: 0,
          splitNumber: 4,
          axisLine: {
            lineStyle: {
              width: 8,
              color: [[0.3, '#74b7d4'], [0.7, '#74b7d4'], [1, '#74b7d4']]
            }
          },
          pointer: {
            itemStyle: {
              color: 'auto',
            }
          },
          detail: {
            formatter: '{value} mm ',
            color: 'auto',
            width: 50,
            // height: 14,
            fontSize: 14,
            // offsetCenter: [0, '40%']
          }
        }]
      };
    },

    change_: function(e) {
      this.checkbox_one_12h = false;
      this.checkbox_one_day = false;
    },

    change_1: function(e) {
      this.checkbox_one_houre = false;
      this.checkbox_one_day = false;
    },

    change_2: function(e) {
      this.checkbox_one_houre = false;
      this.checkbox_one_12h = false;
    },

    edit_min_max() 
    {
      if (this.value_scal == "Min/Max") 
      {
        this.value_scal = "Autoscale";
        this.watermark_1.options.scales.yAxes = [
          {
            display: true,
            ticks: {
              min: Number(this.min),
              max: Number(this.max) + 15 > 100 ? 160 : Number(this.max) + 15,
              callback: function(value, index, values) {
                return value;
              },
            },
          },
        ];

        this.watermark_1.options.scales.xAxes = [
          {
            ticks: {
              callback: function(value, index, values) {
                return index % 3 === 0 ? value : "";
              },
              align: "center",
            },
          },
        ];
      } else {
        this.value_scal = "Min/Max";
        this.watermark_1.options.scales.yAxes = [
          {
            display: true,
        
          },
        ];
      }

      let temp = this.watermark_1.data;
      this.watermark_1.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_1.data = temp;

      temp = this.watermark_2.data;
      this.watermark_2.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_2.data = temp;

      temp = this.watermark_3.data;
      this.watermark_3.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_3.data = temp;

      temp = this.watermark_4.data;
      this.watermark_4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_4.data = temp;

      temp = this.watermark_5.data;
      this.watermark_5.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_5.data = temp;
    },

    clean_chart() {
      this.EC1.data = {
        labels: [],
        series: [[]],
      };
      this.EC2.data = {
        labels: [],
        series: [[]],
      };
      this.EC3.data = {
        labels: [],
        series: [[]],
      };
      this.EC4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_1.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_2.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_3.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_4.data = {
        labels: [],
        series: [[]],
      };
      this.watermark_5.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature1.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature2.data = {
        labels: [],
        series: [[]],
      };
      this.soil_temperature3.data = {
        labels: [],
        series: [[]],
      };
      this.air_humidity.data = {
        labels: [],
        series: [[]],
      };
      this.Temp_air.data = {
        labels: [],
        series: [[]],
      };
      this.Water_count_Flow_Meter.data = {
        labels: [],
        series: [[]],
      };
      this.Water_count_Water_Meter.data = {
        labels: [],
        series: [[]],
      };

      this.Sunlight.data = {
        labels: [],
        series: [[]],
      };
      this.lqi.data = {
        labels: [],
        series: [[]],
      };
      this.rssi.data = {
        labels: [],
        series: [[]],
      };
      this.battery.data = {
        labels: [],
        series: [[]],
      };
    },
    load_data(btn_vl) {
      var days = 2;
      var type = true;

      if (btn_vl == "month") {
        days = 28;
      } else if (btn_vl == "week") {
        days = 7;
      } else if (btn_vl == "day") {
        days = 2;
      } else {
        type = false;
        console.log("- .................. : " + btn_vl);
        days = btn_vl[0];
      }

      let get = this.$router.history.current.query;
      this.clean_chart();

      if (this.dates[1] == undefined) this.dates[1] = this.dates[0];

      function calculateStartDate(endDateStr, days) {
        if (isNaN(days)) {
          return days;
        } else {
          const endDate = new Date(endDateStr);
          endDate.setDate(endDate.getDate() - days);
          endDate.setHours(0, 0, 0, 0);
          let startDate = endDate.toISOString();

          return startDate;
        }
      }

      const { format, parseISO } = require("date-fns");

      let endDate;
      let startDate;
      let waterMeterId = get.id;

      if (type == true) 
      {
        endDate = new Date(this.dates[1]);
        endDate = endDate.toISOString();
        startDate = calculateStartDate(endDate, days);
        GetNodes.sensor_get_dates_fixed(get.id, days, type).then((data) => 
      { 
        setTimeout(() => {
          for (let j = 1; j < data.length; j++) {
            if (data[j] !== undefined && (data[j].S1T || data[j].S1T == 0)) {
 

              this.watermark_1.data.labels.push(
                DateFo.date_chart(data[j].Date)
              );

              if (data[j].S2T || data[j].S2T == 0)
                this.watermark_2.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );

              if (data[j].S3T || data[j].S3T == 0) {
                this.watermark_3.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }

              if (data[j].S4T || data[j].S4T == 0)
                this.watermark_4.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );

              if (data[j].S5T || data[j].S5T == 0)
                this.watermark_5.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              if (data[j].EC1 != null) {
                this.EC1.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].EC2 != null) {
                this.EC2.data.labels.push(DateFo.date_chart(data[j].Date));
              }

              if (data[j].EC3 != null) {
                this.EC3.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].EC4 != null) {
                this.EC4.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].ST1 != null) {
                this.soil_temperature1.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST2 != null) {
                this.soil_temperature2.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST3 != null) {
                this.soil_temperature3.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST4 != null) {
                this.soil_temperature4.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              this.air_humidity.data.labels.push(
                DateFo.date_chart(data[j].Date)
              );

              this.Temp_air.data.labels.push(DateFo.date_chart(data[j].Date));

              this.Sunlight.data.labels.push(DateFo.date_chart(data[j].Date));

              this.lqi.data.labels.push(DateFo.date_chart(data[j].Date));

              this.rssi.data.labels.push(DateFo.date_chart(data[j].Date));
            }
          }

          for (let i = 1; i < data.length; i++) {
            if (data[i] !== undefined && (data[i].S1T || data[i].S1T == 0)) {
              if (data[i].S1T || data[i].S1T == 0)
                this.watermark_1.data.series[0].push(data[i].S1T);
              if (data[i].S2T || data[i].S2T == 0) {
                this.watermark_2.data.series[0].push(data[i].S2T);
              }

              if (data[i].S3T || data[i].S3T == 0) {
          
                this.watermark_3.data.series[0].push(data[i].S3T);
              }
              if (data[i].S4T || data[i].S4T == 0)
                this.watermark_4.data.series[0].push(data[i].S4T);
              if (data[i].S5T || data[i].S5T == 0)
                this.watermark_5.data.series[0].push(data[i].S5T);
              if (data[i].ST1 || data[i].ST1 == 0) {
                this.soil_temperature1.data.series[0].push(data[i].ST1);
              }
              if (data[i].ST2 || data[i].ST2 == 0) {
                this.soil_temperature2.data.series[0].push(data[i].ST2);
              }
              if (data[i].ST3 || data[i].ST3 == 0) {
                this.soil_temperature3.data.series[0].push(data[i].ST3);
              }
              if (data[i].ST4 || data[i].ST4 == 0) {
                this.soil_temperature4.data.series[0].push(data[i].ST4);
              }

              this.air_humidity.data.series[0].push(data[i].HUM);

              this.Temp_air.data.series[0].push(data[i].TEMP);

              this.Sunlight.data.series[0].push(data[i].LX1);

              this.lqi.data.series[0].push(data[i].LW1);

              this.rssi.data.series[0].push(data[i].RSSI);

              this.battery.data.series[0].push(data[i].BAT);
              if (data[i].EC1 != null) {
                this.EC1.data.series[0].push(data[i].EC1);
              }
              if (data[i].EC2 != null) {
                this.EC2.data.series[0].push(data[i].EC2);
              }
              if (data[i].EC3 != null) {
                this.EC3.data.series[0].push(data[i].EC3);
              }
              if (data[i].EC4 != null) {
                this.EC4.data.series[0].push(data[i].EC4);
              }
            }
          }
        }, 500);

        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
      } else 
      {
        let firstDate = new Date(btn_vl[0]);

        let secondDate = new Date(btn_vl[1]) ;
secondDate.setHours(23, 0, 0, 0); // Set to 23:00:00.000

        secondDate = secondDate.toISOString();
        endDate = secondDate;


        firstDate.setDate(firstDate.getDate() - 0);
        firstDate.setHours(0, 0, 0, 0);
        firstDate = firstDate.toISOString();
        startDate = firstDate;


        GetNodes.sensor_get_dates_range(get.id, firstDate, endDate).then((data) => 
      { 
        setTimeout(() => {
          for (let j = 1; j < data.length; j++) {
            if (data[j] !== undefined && (data[j].S1T || data[j].S1T == 0)) {
 

              this.watermark_1.data.labels.push(
                DateFo.date_chart(data[j].Date)
              );

              if (data[j].S2T || data[j].S2T == 0)
                this.watermark_2.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );

              if (data[j].S3T || data[j].S3T == 0) {
                this.watermark_3.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }

              if (data[j].S4T || data[j].S4T == 0)
                this.watermark_4.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );

              if (data[j].S5T || data[j].S5T == 0)
                this.watermark_5.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              if (data[j].EC1 != null) {
                this.EC1.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].EC2 != null) {
                this.EC2.data.labels.push(DateFo.date_chart(data[j].Date));
              }

              if (data[j].EC3 != null) {
                this.EC3.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].EC4 != null) {
                this.EC4.data.labels.push(DateFo.date_chart(data[j].Date));
              }
              if (data[j].ST1 != null) {
                this.soil_temperature1.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST2 != null) {
                this.soil_temperature2.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST3 != null) {
                this.soil_temperature3.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              if (data[j].ST4 != null) {
                this.soil_temperature4.data.labels.push(
                  DateFo.date_chart(data[j].Date)
                );
              }
              this.air_humidity.data.labels.push(
                DateFo.date_chart(data[j].Date)
              );

              this.Temp_air.data.labels.push(DateFo.date_chart(data[j].Date));

              this.Sunlight.data.labels.push(DateFo.date_chart(data[j].Date));

              this.lqi.data.labels.push(DateFo.date_chart(data[j].Date));

              this.rssi.data.labels.push(DateFo.date_chart(data[j].Date));
            }
          }

          for (let i = 1; i < data.length; i++) {
            if (data[i] !== undefined && (data[i].S1T || data[i].S1T == 0)) {
              if (data[i].S1T || data[i].S1T == 0)
                this.watermark_1.data.series[0].push(data[i].S1T);
              if (data[i].S2T || data[i].S2T == 0) {
                this.watermark_2.data.series[0].push(data[i].S2T);
              }

              if (data[i].S3T || data[i].S3T == 0) {
          
                this.watermark_3.data.series[0].push(data[i].S3T);
              }
              if (data[i].S4T || data[i].S4T == 0)
                this.watermark_4.data.series[0].push(data[i].S4T);
              if (data[i].S5T || data[i].S5T == 0)
                this.watermark_5.data.series[0].push(data[i].S5T);
              if (data[i].ST1 || data[i].ST1 == 0) {
                this.soil_temperature1.data.series[0].push(data[i].ST1);
              }
              if (data[i].ST2 || data[i].ST2 == 0) {
                this.soil_temperature2.data.series[0].push(data[i].ST2);
              }
              if (data[i].ST3 || data[i].ST3 == 0) {
                this.soil_temperature3.data.series[0].push(data[i].ST3);
              }
              if (data[i].ST4 || data[i].ST4 == 0) {
                this.soil_temperature4.data.series[0].push(data[i].ST4);
              }

              this.air_humidity.data.series[0].push(data[i].HUM);

              this.Temp_air.data.series[0].push(data[i].TEMP);

              this.Sunlight.data.series[0].push(data[i].LX1);

              this.lqi.data.series[0].push(data[i].LW1);

              this.rssi.data.series[0].push(data[i].RSSI);

              this.battery.data.series[0].push(data[i].BAT);
              if (data[i].EC1 != null) {
                this.EC1.data.series[0].push(data[i].EC1);
              }
              if (data[i].EC2 != null) {
                this.EC2.data.series[0].push(data[i].EC2);
              }
              if (data[i].EC3 != null) {
                this.EC3.data.series[0].push(data[i].EC3);
              }
              if (data[i].EC4 != null) {
                this.EC4.data.series[0].push(data[i].EC4);
              }
            }
          }
        }, 500);

        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
      }

      GetNodes.getLoraData(startDate, endDate, waterMeterId)
        .then((data) => {
          // handle your data here
          let labels = [];
          let seriesData = [];

          let seriesData_Water_Meter = [];
          let seriesData_Quantity_meter = [];

          data.data_lora[0].values.forEach((value) => {
            // Parse the date from your API response and formà it as 'dd/MM HH:mm'
            let formattedDate = format(parseISO(value.Datetime), "dd/MM HH:mm");
            labels.push(formattedDate);
            seriesData.push(value.Flow_Meter); // or use value.Water_Meter depending on your need
            seriesData_Water_Meter.push(value.Water_Meter);
            seriesData_Quantity_meter.push(value.Quantity_Meter);
            console.log(value.Quantity_Meter);
          });

          this.Water_count_Flow_Meter.data = {
            labels: labels,
            series: [seriesData],
          };

          this.Water_count_Water_Meter.data = {
            labels: labels,
            series: [seriesData_Water_Meter],
          };

          this.Water_count_Quantity_meter.data = {
            labels: labels,
            series: [seriesData_Quantity_meter],
          };
        })
        .catch((error) => {
          // handle your error here
        });
    },
    changeRoute_culture(selectObj) {
      this.items_culture.forEach((el, index) => {
        if (el === selectObj) {
          this.cult = index;
          // alert("changeRoute_culture");
        }
      });
    },
    changeRoute_irrig(selectObj) {
      this.items.forEach((el, index) => {
        if (el === selectObj) {
          this.is = index;
          // alert("changeRoute_irrig");
        }
      });
    },
    update(data, options, override) {
      if (data) {
        this.data = data || {};
        this.data.labels = this.data.labels || [];
        this.data.series = this.data.series || [];
        // Event for data transformation thà allows to manipulate the data before it gets rendered in the charts
        this.eventEmitter.emit("data", {
          type: "update",
          data: this.data,
        });
      }

      if (options) {
        this.options = Chartist.extend(
          {},
          override ? this.options : this.defaultOptions,
          options
        );

        // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
        // Otherwise we re-create the optionsProvider à this point
        if (!this.initializeTimeoutId) {
          this.optionsProvider.removeMediaQueryListeners();
          this.optionsProvider = Chartist.optionsProvider(
            this.options,
            this.responsiveOptions,
            this.eventEmitter
          );
        }
      }

      // Only re-created the chart if it has been initialized yet
      if (!this.initializeTimeoutId) {
        this.createChart(this.optionsProvider.getCurrentOptions());
      }

      // Return a reference to the chart object to chain up calls
      return this;
    },
    openLoading() {
      if (this.loading === true) {
        const loading = this.$vs.loading({
          target: this.$refs.content,
          color: "dark",
          type: "circles",
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
      }
    },
    Myfunction() {
      this.validated = !this.validated;
    },
    editnode() {
      let get = this.$router.history.current.query;
      let d = {
        Clay: this.clay,
        Limon: this.Limon,
        RFUMAX: this.RFUMAX,
        RFUMIN: this.RFUMIN,
        Sand: this.sand,
        min: this.min,
        max: this.max,
        FarmerName: this.fname,
        NodeId: this.nodeId,
        latitude: this.lat,
        Culture: this.cult,
        pycno_prof: this.prof_pycno,
        longitude: this.long,
        Totalarea: this.st,
        IrrigationSystem: this.is,
        CropDensit1: this.cd1,
        CropDensit2: this.cd2,
        depthroot: this.rootd,
        DripppersFlowrate: this.frod,
        DrippersSpaces: this.sod,
        Numberramps: this.nor,
        Cofficientuinf: this.cou,
        Irrigationefficiency: this.ire,
        Soilsalinity: this.Ss,
        OrganicMatter: this.oms,
        Soiltextue: this.Soil,
        Date: this.date1.substr(0, 10),
      };

      GetNodes.editnode(get.id, d)
        .then(() => (this.errdata = "Updated"))
        .catch(() => (this.err = "Check the fields and try again"));
    },
    edit_on_off(of, id) {
      if (of == 30) var active = 31;
      else var active = 30;

      GetNodes.edit_on_off(active, id)
        .then((data) => {
          console.log("connecte here" + data);
          this.On_Off = data.data;
        })
        .catch(() => (this.err = "Check the fields and try again"));
    },
    clear() {
      (this.clay = ""),
        (this.Limon = ""),
        (this.RFUMAX = ""),
        (this.RFUMIN = ""),
        (this.sand = ""),
        (this.fname = ""),
        (this.nodeId = ""),
        (this.lat = ""),
        (this.cult = ""),
        (this.prof_pycno = ""),
        (this.long = ""),
        (this.st = ""),
        (this.is = ""),
        (this.cd1 = ""),
        (this.cd2 = ""),
        (this.rootd = ""),
        (this.frod = ""),
        (this.sod = ""),
        (this.nor = ""),
        (this.cou = ""),
        (this.ire = ""),
        (this.Ss = ""),
        (this.oms = ""),
        (this.Soil = "");
      this.min = "";
      this.max = "";
    },
    submit() {
      this.$v.nodeId.$touch();
      this.$v.fname.$touch();
      this.$v.lat.$touch();
      this.$v.long.$touch();
      this.$v.st.$touch();
      // this.$v.ws.$touch();
      this.$v.is.$touch();
      // this.$v.isn.$touch();

      console.log("dkhlaaaat");
      console.log(this.e1);
      if (
        !this.$v.nodeId.$error &&
        !this.$v.lat.$error &&
        !this.$v.long.$error &&
        !this.$v.st.$error &&
        !this.$v.is.$error &&
        !this.$v.fname.$error
      ) {
        console.log("dkhlaaat bla error");
        console.log(this.e1);
        this.e1 = 2;
        console.log(this.e1);
      }
    },
    submitII() {
      this.$v.ire.$touch();
      this.$v.cou.$touch();
      this.$v.nor.$touch();
      this.$v.sod.$touch();
      this.$v.frod.$touch();
      this.$v.rootd.$touch();
      this.$v.cd2.$touch();
      this.$v.cd1.$touch();
      this.$v.cult.$touch();
      this.$v.prof_pycno.$touch();

      if (
        !this.$v.ire.$error &&
        !this.$v.cou.$error &&
        !this.$v.nor.$error &&
        !this.$v.rootd.$error &&
        !this.$v.frod.$error &&
        !this.$v.sod.$error &&
        !this.$v.cd2.$error &&
        !this.$v.cd1.$error &&
        !this.$v.cult.$error &&
        !this.$v.prof_pycno.$error
      ) {
        this.e1 = 3;
        console.log(this.e1);
      }
    },
    getinfos() {
      router.push("/infos?id=" + this.$router.history.current.query.id);
    },
    ft_export() {
      this.loader = "loading1";
      let get = this.$router.history.current.query;
      if (
        !isEmpty(this.start) &&
        !isEmpty(this.end) &&
        !isEmpty(this.starttime) &&
        !isEmpty(this.endtime)
      ) {
        this.starttime = "T" + this.starttime;
        this.endtime = "T" + this.endtime;

        this.starttime += ":00.000Z";
        this.endtime += ":00.000Z";

        this.start += this.starttime;
        this.end += this.endtime;

        let value_check =
          this.checkbox_one_houre == true
            ? 1
            : this.checkbox_one_12h == true
            ? 2
            : 3;

        //1 -- >  Every hour
        //2 -- >  Every 12h
        //3 -- >  Every Day
        GetNodes.check_data(get.id, this.start, this.end, value_check)
          .then(
            (result) => {
              if (result.data) {
                GetNodes.export_data(get.id, this.start, this.end, value_check)
                  .then(
                    () => {
                      setTimeout(function() {
                        window.open(
                          "https://agriedge.ca/aquaedgeweb/exportData/Node-" +
                            get.id +
                            ".xlsx",
                          "_blank"
                        );
                      }, 9900);
                    }

                    // GetNodes.download(get.id)
                  )
                  .catch((err) => console.log(err));
              } else {
                alert(
                  "Don't find data for this Date :" +
                    this.start +
                    "  ,  " +
                    this.end
                );
              }
            }
            // GetNodes.download(get.id)
          )
          .catch((err) => console.log(err));
      } else alert("check the fields");
    },
  },
  watch: {
    $route: function() {
      console.log("here route ");
      if (this.$route.query.tab) {
        this.activeTab = Number(this.$route.query.tab);
        console.log("here tab ");
        console.log(this.activeTab);
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 5000);
      this.loader = null;
    },
  },
  beforeCreate() {
    let get = this.$router.history.current.query;
    // GetNodes.getValue_Vanne().then((vn)=>{
    //   // console.log("############################################");
    //     if(vn[0]["2"] == 0)
    //     {
    //       this.On_Off = true;
    //     }
    //     else
    //     {
    //       this.On_Off = false;
    //     }
    // })
    GetNodes.getNodeDetails(get.id)
      .then((res) => {
        if (isEmpty(res)) router.push("/table");

        (this.clay = res.Clay),
          (this.Limon = res.Limon),
          (this.RFUMAX = res.RFUMAX),
          (this.RFUMIN = res.RFUMIN),
          (this.sand = res.Sand),
          (this.min = res.min),
          (this.max = res.max),
          (this.fname = res.FarmerName),
          (this.nodeId = res.NodeId),
          (this.lat = res.latitude),
          (this.cult = res.Culture),
          (this.prof_pycno = res.pycno_prof),
          (this.long = res.longitude),
          (this.st = res.Totalarea),
          (this.is = res.IrrigationSystem),
          (this.cd1 = res.CropDensit1),
          (this.cd2 = res.CropDensit2),
          (this.rootd = res.depthroot),
          (this.frod = res.DripppersFlowrate),
          (this.sod = res.DrippersSpaces),
          (this.nor = res.Numberramps),
          (this.cou = res.Cofficientuinf),
          (this.ire = res.Irrigationefficiency),
          (this.Ss = res.Soilsalinity),
          (this.oms = res.OrganicMatter),
          (this.Soil = res.Soiltextue),
          // (this.On_Off = res.on_off),
          (this.e1 = 1);

        if (res.Date) this.date1 = res.Date.substr(0, 10);

        if (res.DateD) this.dateD = res.DateD.substr(0, 10);

        this.details = res;

        if (this.details.Date)
          this.details.Date = this.details.Date.substr(0, 10);

        GetNodes.getvanneAPI(get.id).then((data) => {
          console.log("dev vanne here");
          console.log(data);

          if (data) {
            this.isConnected = data.connection_status !== "offline";
            this.On_Off = data.data;
          }
        });

        return GetNodes.getWeatherData(res.latitude, res.longitude);
      })
      .then((data) => {
        this.weath = data.list;
        this.$store.state.weath = data.list;
        console.log(data);
        this.place = data.city.name;
        console.log("Place : " + this.place);
      });
  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = Number(this.$route.query.tab);
    }
    this.load_data("day");
  },
  mounted() {
    this.openLoading();
  },
};
</script>

<style scoped>
.content-div {
  width: 200px;
  height: 200px;
  box-shadow: 0px 6px 25px -10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 0.6rem;
}

.tba {
  font-size: 50px;
  color: black;
}

/** App **/
label {
  display: block;
  font: 1rem "Fira Sans", sans-serif;
}

input,
label {
  margin: 0.4rem 0;
}

.app {
  height: 100vh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.app--day a:hover {
  color: rgba(46, 146, 167, 0.9);
}

.app--night a:hover {
  color: rgba(0, 0, 0, 0.5);
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.chart-container {
  position: relative;
  width: 100%;
  display: flex;
}

.echart-container {
  height: 300px;
}
</style>
